import { z } from 'zod/v3';
import { generateId } from './utils';

const LogDataAttributeSchema = z.object({
  attribute: z.string(),
  id: z.string(),
  value: z.string(),
});
export const LogDataSchema = z.object({
  logData: z.array(LogDataAttributeSchema),
  logData2: z.array(LogDataAttributeSchema),
});

export type LogDataAttributeType = z.infer<typeof LogDataAttributeSchema>;
export type LogDataType = z.infer<typeof LogDataSchema>;

export const DEFAULT_ATTRIBUTE: LogDataAttributeType = {
  attribute: '',
  id: '',
  value: '',
};

export const DEFAULT_VALUES = {
  logData: [
    {
      ...DEFAULT_ATTRIBUTE,
      id: generateId(),
    },
  ],
  logData2: [
    {
      ...DEFAULT_ATTRIBUTE,
      id: generateId(),
    },
  ],
};
